import Section from '@/components/Section'
import React from 'react'
import Head from './components/Head'
import Lectures from './components/Lectures'

const UrbanClub = (): React.ReactElement => {
  return (
    <Section>
      <Head />

      <Lectures />
    </Section>
  )
}

export default UrbanClub
